import { Link } from 'react-router-dom';
import { APISERVERURL } from '../APIServerURL';

const PeopleCard = ({ post }) => {
  const to = `/editpeople/${post._id}`;
  const imgName = post.images && post.images.length > 0 ? post.images[0] : 'default.png';

  return (
    <Link
  to={to}
  className="w-[300px] h-[450px] bg-white shadow-lg rounded-2xl overflow-hidden hover:shadow-2xl hover:scale-105 transition-transform duration-300 relative"
>
  <div className="block w-full h-[300px] overflow-hidden">
    <img
      src={`${APISERVERURL}/img/${imgName}`}
      alt="placeholder"
      className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-500"
    />
  </div>
  <div className="w-full h-[150px] flex flex-col justify-center items-center overflow-y-auto p-2 text-xs bg-blue-100  transition-colors duration-300 hover:bg-blue-600 hover:text-white">
  <p className="text-sm font-semibold">{post.name}</p>
  <p>{post.designation}</p>
  <p>{post.qualification}</p>
  <p>{post.contactNumberToDisplay}</p>
  <p>{post.email}</p>
  <p>{post.peopleGroup.join(", ")}</p>
  <p>{`Published:${post.publishInWebsite}`}</p>
</div>
</Link>


  );
};

export default PeopleCard;
